import { useSnackbar } from 'notistack'

export const useSnackBar = () => {
  const { enqueueSnackbar } = useSnackbar()

  const dispatchSnack = (message: string) => {
    return enqueueSnackbar({
      message,
      variant: 'success',
      anchorOrigin: { horizontal: 'center', vertical: 'bottom' },
      autoHideDuration: 5000
    })
  }

  return { dispatchSnack }
}
